var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-view"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"video-box"},_vm._l((_vm.videoList),function(v){return _c('div',{key:v.id,staticClass:"video-item",staticStyle:{"height":"50%"}},[_c('flv-player',{attrs:{"switch-url":v.switchUrl,"video-url":v.videoUrl}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }